import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_PRESTA_API_URL
})

api.interceptors.request.use( config => {
  const token = localStorage.getItem('token')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

export {
    api
}
